import PropTypes from 'prop-types';
import { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography
} from '@mui/material';
import { ErrorOutline } from '@mui/icons-material';
import { DataContext } from '../DataProviders/DataProvider';

const ProfileStatusContext = createContext();

const ProfileStatusProvider = ({ children }) => {
    const { profileComplete } = useContext(DataContext);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isClosable, setIsClosable] = useState(true);
    const navigate = useNavigate();

    const { totalPercentageProfileCompleted } = profileComplete;

    const showModal = () => {
        if (totalPercentageProfileCompleted < 100) {
            setIsClosable(false);
            setIsModalOpen(true);
        } else {
            setIsClosable(true);
            setIsModalOpen(false);
        }
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const RouteChange = () => {
        navigate('/settings');
        setIsModalOpen(false);
    };

    return (
        <ProfileStatusContext.Provider
            value={{
                isModalOpen,
                setIsModalOpen,
                isClosable,
                setIsClosable,
                handleOk,
                showModal,
                handleCancel
            }}
        >
            {children}

            <Dialog
                open={isModalOpen}
                onClose={isClosable ? handleCancel : null}
                fullWidth
                maxWidth="xs"
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        p: 2,
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        fontWeight: 'bold',
                        pb: 0
                    }}
                >
                    <ErrorOutline color="warning" />
                    <Typography variant="h6" sx={{ flexGrow: 1 }}>
                        Profile Update Required
                    </Typography>
                </DialogTitle>

                <DialogContent sx={{ py: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                        Please complete your profile before placing an order.
                    </Typography>
                </DialogContent>

                <DialogActions sx={{ justifyContent: 'flex-end' }}>
                    <Button
                        onClick={RouteChange}
                        variant="contained"
                        sx={{
                            borderRadius: 2,
                            textTransform: 'none',
                            px: 3,
                            boxShadow: 'none',
                        }}
                        autoFocus
                    >
                        Update Profile
                    </Button>
                </DialogActions>
            </Dialog>
        </ProfileStatusContext.Provider>
    );
};

ProfileStatusProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export { ProfileStatusContext, ProfileStatusProvider };
